import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
// import { useEffect, useState } from "react";
// import axios from "../api/axios";
// import { useParams } from "react-router-dom";
// import Dish from "../Home/Dish";
import { default as Item } from "./Dish";

const Cart = () => {
	const cart = useSelector((state) => state.cart.value);
	// const params = useParams();
	// const [recommend, setRecommend] = useState(false);
	// const [dish, setDish] = useState([]);
	// const [count, setCount] = useState(null);

	// useEffect(() => {
	// 	if (cart.length > 0) {
	// 		if (cart.length !== count) {
	// 			axios
	// 				.post(
	// 					`${
	// 						process.env.REACT_APP_API
	// 							? process.env.REACT_APP_API
	// 							: "http://127.0.0.1:8000/api"
	// 					}/get-recommendation`,
	// 					{
	// 						order: cart,
	// 						res: params.rid,
	// 					}
	// 				)
	// 				.then((res) => {
	// 					setDish(res.data.data);
	// 					setRecommend(true);
	// 				})
	// 				.catch((err) => console.log(err));

	// 			setCount(cart.length);
	// 		}
	// 	}
	// }, [cart, params.rid, count]);

	return (
		<>
			<Helmet>
				<title>Cart</title>
			</Helmet>

			<div className="container-fluid">
				<div id="fda_app" className="row">
					<section className="fda_section_product_tile col-12">
						<div className="row fda_title_row">
							<div className="col-12">
								<span>
									<p
										color="#363636"
										className="littleline1"
										style={{ marginTop: "90px" }}
									>
										{cart.length === 0 ? "Empty Food Basket" : "Food Basket"}
									</p>
								</span>
							</div>
						</div>

						{cart.map((dish) => (
							<Item key={dish.id} dish={dish} />
						))}
					</section>

					{/* <section id="fda_product_tile_r" className="col-12 hid">
						{recommend && dish.length > 0 && (
							<>
								<p color="#363636" className="littleline">
									Recommendations
								</p>

								<div className="row fda_food_row">
									{dish.map((d) => (
										<Dish key={d.id} dish={d} />
									))}
								</div>
							</>
						)}
					</section> */}
				</div>
			</div>
		</>
	);
};

export default Cart;
